import { Stack, StackProps, styled } from '@mui/material';

import { generateClasses } from '../../../utils/helper';

export const tileClassesFormClasses = generateClasses('ActivityClassesForm', ['classList']);

export const Content = styled((props: StackProps) => <Stack flex={1} gap={2} {...props} />)(({ theme }) => ({
  overflow: 'hidden',
  color: theme.palette.common.black,
  [`& .${tileClassesFormClasses.classList}`]: {
    overflow: 'auto',
    flex: 1,
  },
}));
